import { useEffect, useRef } from "react";
import {
  useCentraContext,
  useCentraReducerDispatch,
  useCentraSelectionResponse,
} from "@made-people/grease-centra";
import { useCartState } from "@made-people/grease-cart";
import { useCountriesAndLanguages } from "@made-people/grease-countries-and-languages";
import { CentraShippingMethod } from "@made-people/centra-checkout-api";
import { isAllCartItemsOMG } from "../utils/is-all-cart-items-in-omg";

export const useAutoSwitchFromExpressShipping = () => {
  const selectionResponse = useCentraSelectionResponse();
  const { cart } = useCartState();
  const { checkoutAPIClient } = useCentraContext();
  const dispatch = useCentraReducerDispatch();
  const switchingRef = useRef(false);
  const { currentCountryCode } = useCountriesAndLanguages();

  const allInOMG = isAllCartItemsOMG(cart?.items ?? [], currentCountryCode);
  const shippingMethods = selectionResponse?.shippingMethods ?? [];
  const selectedMethod = selectionResponse?.selection?.shippingMethod;
  const expressIsSelected = selectedMethod === "EXPRESS";
  const shouldSwitch = !allInOMG && expressIsSelected;

  const fallbackMethod = shippingMethods.find(
    (m) => m.shippingMethod !== "EXPRESS",
  )?.shippingMethod;

  useEffect(() => {
    if (!shouldSwitch || !fallbackMethod || switchingRef.current) {
      return;
    }

    switchingRef.current = true;
    checkoutAPIClient
      .setShippingMethod({ shippingMethod: fallbackMethod })
      .then(({ success }) => {
        if (success) {
          dispatch({
            type: "SET_SELECTION_RESPONSE",
            payload: { selectionResponse: success },
          });
        }
      })
      .finally(() => {
        switchingRef.current = false;
      });
  }, [cart?.items]);
};

export const useExpressShippingFilter = (): CentraShippingMethod[] => {
  const selectionResponse = useCentraSelectionResponse();
  const { cart } = useCartState();
  const { currentCountryCode } = useCountriesAndLanguages();
  const allInOMG = isAllCartItemsOMG(cart?.items ?? [], currentCountryCode);

  return (selectionResponse?.shippingMethods ?? []).filter(
    (method) => allInOMG || method.shippingMethod !== "EXPRESS",
  );
};
